import wixWindow from 'wix-window';

// ...

let formFactor = wixWindow.formFactor;  // "Mobile"

export function button3_click(event) {
	//Add your code for this event here: mndbdy.ly/e/38122
}